<template>
  <div class="membershipPage">
    <div class="bannerBox clearfix">
      <!-- <img src="https://html.qiniu.jihelife.com/website/title.png"> -->
    </div>
    <div class="contentBox">
      <img class="contentImg" src="https://htmlqiniu.jihex.com/priceContentImg.png" alt="">
      <div @click="cooperateClick" class="cooperateBtn"></div>
      <div @click="tryOutBtnClick" class="tryOutBtn"></div>
    </div>
    <div class="cooperateBox">
      <el-dialog title="" width="650px" :visible.sync="cooperateDia">
        <img class="cooperateImg" src="https://htmlqiniu.jihex.com/%E6%B7%B1%E5%BA%A6%E5%90%88%E4%BD%9C_%E8%81%94%E7%B3%BB%E5%95%86%E5%8A%A1%402x.png" alt="">
      </el-dialog>
    </div>
  </div>
</template>
<script>
import webHost from '@/api/config.js'
export default {
  data () {
    return {
      cooperateDia:false,
    }
  },
  methods : {
    cooperateClick() {
      this.cooperateDia = true
    },
    tryOutBtnClick() {
      window.open(`${webHost}/#/login?isRegisterShow=true`)
    }
  },
  beforeCreate () {
    document.title = this.$route.meta.title
  }
}
</script>
<style lang="scss" scoped>
.membershipPage {
  min-width: 1200;
}
.bannerBox {
  width: 100%;
  min-width: 1200px;
  height: 610px;
  background: url(https://htmlqiniu.jihex.com/priceBanner.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
  display:table;
  img {
    width: 413px;
    height: 58px;
    display: block;
    margin: 0 auto;
    margin-top: 72px;
  }
}
.contentBox {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  margin-top: -135px;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 40px;
  .contentImg {
    width: 1180px;
    height: 606px;
    border-radius: 10px;
    box-shadow: 0px 0px 40px 0px rgba(42, 54, 65, 0.04);
  }
  .cooperateBtn {
    width: 192px;
    height: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(-202px);
    top: -98px;
    &:hover {
      cursor: pointer;
    }
  }
  .tryOutBtn {
    width: 192px;
    height: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(10px);
    top: -98px;
    &:hover {
      cursor: pointer;
    }
  }
}
.cooperateImg {
  width: 650px;
  height: 224px;
  display: block;
}
.clearfix::before{ 
  content: ”; 
  display: table; 
} 
</style>
<style>
.cooperateBox .el-dialog__body {
  padding: 0px;
  padding-top: 16px;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/view/membership.vue